/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { CSSProperties } from 'react';
import { CoreColors } from '../../../styles/teams';

export const titleStyles: CSSProperties = {
    color: CoreColors.appGray16,
};
